import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TripContext from "../../../context/trip/context";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import EndPoints from "../../../services/end-points";
import { TripStatus } from "../../../models/trip/response";
import { createActiveStoreFilter } from "../../../utils/helpers/store-filters";

interface IProps { }

const TripFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(TripContext);
  const [drivers, setDrivers] = useState<any[]>([]);
  const [stores, setStores] = useState<any[]>([]);

  const statusOptions = [
    { label: t("preparing"), value: TripStatus.PENDING },
    { label: t("delivery_in_progress"), value: TripStatus.ACTIVE },
    { label: t("completed"), value: TripStatus.COMPLETED },
    { label: t("cancelled"), value: TripStatus.CANCELLED },
  ];

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const response = await EndPoints.deliveryWorkers.getAllDeliveryWorkers({
          light: true,
          perPage: -1,
        });
        setDrivers(
          response.data.data.map((driver: any) => ({
            label: `${driver.firstName} ${driver.lastName}`,
            value: driver.id,
          }))
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchStores = async () => {
      try {
        const response = await EndPoints.store.getAllStores({
          light: true,
          perPage: -1,
          filters: [createActiveStoreFilter()],
        });
        setStores(
          response.data.data.map((store: any) => ({
            label: store.name,
            value: store.id,
          }))
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchDrivers();
    fetchStores();
  }, []);

  return (
    <Form
      formId="trip-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.driverId
              ? {
                name: "driverId",
                value: data.driverId,
                operation: "eq",
              }
              : undefined,
            data?.storeId
              ? {
                name: "storeId",
                value: data.storeId,
                operation: "eq",
              }
              : undefined,
            data?.status !== undefined && data?.status !== null
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
            data?.startedAtFrom
              ? {
                name: "startedAt",
                value: data.startedAtFrom,
                operation: "gte",
              }
              : undefined,
            data?.startedAtTo
              ? {
                name: "startedAt",
                value: data.startedAtTo,
                operation: "lte",
              }
              : undefined,
            data?.completedAtFrom
              ? {
                name: "completedAt",
                value: data.completedAtFrom,
                operation: "gte",
              }
              : undefined,
            data?.completedAtTo
              ? {
                name: "completedAt",
                value: data.completedAtTo,
                operation: "lte",
              }
              : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="driverId"
            label={t("driver")}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              options: drivers,
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="storeId"
            label={t("store")}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              options: stores,
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="status"
            label={t("status")}
            width="large"
            input={{
              type: "select",
              options: statusOptions,
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="startedAtFrom"
            label={t("started_at_from")}
            width="large"
            input={{
              type: "date-picker",
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="startedAtTo"
            label={t("started_at_to")}
            width="large"
            input={{
              type: "date-picker",
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="completedAtFrom"
            label={t("completed_at_from")}
            width="large"
            input={{
              type: "date-picker",
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="completedAtTo"
            label={t("completed_at_to")}
            width="large"
            input={{
              type: "date-picker",
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default TripFilter;
